import React from 'react';
import { Link } from 'react-router-dom';
import LivePreview from '../LivePreview';

export default function SharedPreviewView({ project, files, previewUrl, previewReady, shareToken }) {
  const hasFiles = files && Object.keys(files).length > 0;

  return (
    <div style={s.container}>
      <header style={s.header}>
        <div style={s.headerLeft}>
          <Link to="/" style={s.brand}>DS CodeXAI</Link>
          <span style={s.divider} aria-hidden>|</span>
          <h1 style={s.projectName}>{project?.name || 'Shared Project'}</h1>
        </div>
        <div style={s.headerRight}>
          <span style={s.meta}>Shared via DS CodeXAI</span>
        </div>
      </header>

      <main style={s.main}>
        {hasFiles ? (
          <LivePreview files={files} shareToken={shareToken} />
        ) : (
          <div style={s.empty}>
            <p style={s.emptyTitle}>Preview is being prepared.</p>
            <p style={s.emptyText}>Please try again shortly.</p>
          </div>
        )}
      </main>
    </div>
  );
}

const s = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflow: 'hidden',
    background: 'var(--bg-primary)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
    flexWrap: 'wrap',
    padding: '14px 24px',
    borderBottom: '1px solid var(--border)',
    background: 'var(--bg-secondary)',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
    minWidth: 0,
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
  },
  brand: {
    fontSize: 14,
    fontWeight: 700,
    color: 'var(--accent-light)',
    textDecoration: 'none',
  },
  divider: { color: 'var(--text-muted)', opacity: 0.4 },
  projectName: {
    fontSize: 17,
    fontWeight: 700,
    color: 'var(--text-primary)',
    margin: 0,
  },
  meta: { fontSize: 12, color: 'var(--text-muted)' },
  main: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  empty: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    textAlign: 'center',
  },
  emptyTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: 'var(--text-primary)',
    margin: '0 0 8px',
  },
  emptyText: {
    fontSize: 14,
    color: 'var(--text-secondary)',
    margin: 0,
  },
};
